import React from "react";
import FolieLayout from "./FolieLayout.jsx";
import FlussSchaubild from "./FlussSchaubild.jsx";

export default function Folie1Fluss() {
    return (
        <FolieLayout
            nummer={2}
            titel="Wie die Zahlen zusammenlaufen"
            hilfe="Fünf Datenquellen fließen in einen gemeinsamen Rechenkern, aus dem die drei Bildschirme des Bereichs entstehen."
            text={
                <p className="mb-0">
                    Der Bereich fasst fünf Quellen zusammen: die eigenen Verkäufe, den Lagerbestand, offene
                    Kundenaufträge, Cosmos’ Zusagen aus der Ampel-Datei und die Nachfrage aus dem B2B-Shop. Alles läuft
                    in einem gemeinsamen Rechenkern zusammen und wird von dort auf die drei Bildschirme verteilt.
                    Welcher Teil der Verkäufe ab SNV Weilheim und welcher ab Lahr ging, liefert die
                    Warenbewegungsdatei von Schneider Novus – damit wird der Verbrauch je Lager getrennt (Folie „Wochenbedarf und Saison“).
                </p>
            }
            leseHinweis='Jede Zahl im Bereich lässt sich auf eine dieser fünf Quellen zurückführen – links, wo sie herkommt, rechts, wo sie erscheint. Details zu jeder Quelle stehen weiter unten unter „Alle Quellen im Detail“.'
        >
            <FlussSchaubild />
        </FolieLayout>
    );
}
